import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { FilterTransport } from '../../transports/filters-configuration-transport'
import { getPopularFilters } from './selectors'

export const usePopularFilters = (title?: string): FilterTransport => {
    const popularFiltersData = useSelector(getPopularFilters)
    return useMemo(() => ({ ...popularFiltersData, title: title ?? '' }), [popularFiltersData, title])
}
